import './App.css';
import { useState, useEffect } from 'react';
import CampaignForm from './components/CampaignForm';
import SettingsModal from './components/SettingsModal';
import CampaignTable from './components/CampaignTable';
import LoginForm from './components/LoginForm';
import SignupForm from './components/SignupForm';
import Footer from './components/Footer';
import NewPasswordForm from './components/NewPasswordForm';
import UserBox from './components/UserBox';
import ShadowLogo from './images/am-logo-large-dropshadow.png';
import {
  HeroUIProvider,
  ToastProvider,
  // addToast,
  Button,
  Alert
} from "@heroui/react";
import Logo from './images/logo.png';
// import FacebookLogin from 'react-facebook-login';
import { googleLogout } from '@react-oauth/google';
import { Client } from '@stomp/stompjs';

function App() {
  const [user, setUser] = useState();
  const [showForm, setShowForm] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const active = new URLSearchParams(window.location.search).get('active');
  const [showLogin, setShowLogin] = useState((active && active === 'login') ? true : false);
  const [showSignup, setShowSignup] = useState(active && active === 'signup' ? true : false);
  const [banner, setBanner] = useState(new URLSearchParams(window.location.search).get('info'));
  const [error, setError] = useState(new URLSearchParams(window.location.search).get('error'));
  const [showSettings, setShowSettings] = useState();
  const [editingCampaign, setEditingCampaign] = useState();
  const [resetToken, setResetToken]  = useState(new URLSearchParams(window.location.search).get('reset_token'));
  const [stompClient, setStompClient] = useState();

  useEffect(() => {
    const stompInit = (user) => {
      const stompUrl = `wss://${window.location.host}/ws`;
      const client = new Client({
        brokerURL: stompUrl,
        connectHeaders: {
          login: 'guest',
          passcode: 'guest',
          host: window.location.host,
          saslMechanism: 'ANONYMOUS'
        },
        debug: function(str) {
          console.log('STOMP DEBUG: ' + str)
        },
        heartbeatIncoming: 20000,
        heartbeatOutgoing: 20000,
        reconnectDelay: 1000,
        onStompError: (frame) => {
          console.log('STOMP: Got ERROR: ' + JSON.stringify(frame));
        }
      });
      client.onConnect = (frame) => {
        console.log('STOMP: Got connect: ' + JSON.stringify(frame));
        setStompClient(client);
      }
      client.activate();
    };

    if (window.location.href.indexOf('b=ex') !== -1) {
      setError('That campaign program has been fully utilized.');
      window.history.replaceState({}, 'ActivistMailer', '/');
    }
    if (error) {
      // setError(error);
      window.history.replaceState({}, 'ActivistMailer', '/');
    }
    if (banner) {
      // setBanner(banner);
      window.history.replaceState({}, 'ActivistMailer', '/');
    }
    const getme = async () => {
      const me = await fetch('/api/v1/me');
      if (me.status === 200) {
        const userData = await me.json();
        if (userData?.user) {
          setUser(userData['user'])
          setShowSignup(false);
          setShowLogin(false);
          stompInit(userData?.user);
        } else {
          if (!showSignup) {
            setShowLogin(true);
          }
        }
      } else {
        if (!showSignup) {
          setShowLogin(true);
        }
      }
    };
    getme();
  }, [error, banner, showSignup]);

  const logout = async () => {
    if (user.provider && user.provider.indexOf('oogl') !== -1) {
      googleLogout();
    }
    const log = await fetch('/api/v1/users/sign_out', {method: 'DELETE'});
    if (log.status === 204) {
      setUser();
      window.location.reload();
    } else {
      alert('Logout failed.  Please refresh your browser and try again.');
    }
  };

  const setShowFormWrapper = () => {
    setEditingCampaign();
    setShowForm(true);
  };

  const handleLogin = (u) => {
    setShowLogin(false);
    setShowSignup(false);
    setUser(u);
  };

  const cancelForm = (shouldRefresh = false) => {
    setShowForm(false);
    if (shouldRefresh) {
      setRefreshTrigger(prev => prev + 1);
    }
  };

  const editCampaign = (campaign) => {
    setEditingCampaign(campaign);
    setShowForm(true);
  };

  const showLoginWrapper = () => {
    setShowLogin(true);
    setShowSignup(false);
  }

  return (
    <HeroUIProvider>
      <ToastProvider />
        <UserBox user={user} showLogin={showLogin} showSignup={showSignup}
                 displaySignup={() => {setShowLogin(false); setShowSignup(true)}} displayLogin={showLoginWrapper}
                 displaySettings={() => setShowSettings(true)} logout={logout}
                 setError={setError} setBanner={setBanner} setUser={setUser}
        />
        <div className='App'>
          { user && <a href='/'><img src={Logo} className='main-logo-logged-in' alt='ActivistMailer Logo' /></a> }
          { !user && <a href='/'><img src={Logo} className='main-logo' alt='ActivistMailer Logo' /></a> }
          { banner && <div className='alert'><Alert isClosable variant='solid' color='success' title={banner} onClose={() => setBanner()} /></div> }
          { error && <div className='alert'><Alert isClosable variant='solid' color='danger' title={error} onClose={() => setError()} /></div> }
          { !showForm ? <img alt='ActivistMailer' style={{width: '75vw', maxWidth: '385px', zIndex: 41}} src={ShadowLogo} /> : 'Start an email campaign that will get through!' }
          <div className='spacer' />
          { resetToken && <NewPasswordForm dismissModal={() => setResetToken()} /> }
          { showSettings && <SettingsModal user={user} setUser={setUser} dismissModal={() => setShowSettings(false)} /> }
          { (showLogin && !user)
              && <LoginForm setBanner={setBanner} setuser={(u) => handleLogin(u)} />
          }
          { showSignup && <SignupForm setMessage={setBanner} setShowLogin={setShowLogin} setShowSignup={setShowSignup} /> }
          { (user && !showForm)
              && <div style={{width: '94%', marginTop: '-35px', marginBottom: '35px', zIndex: 41}}>
                   <Button color='success' onClick={() => setShowFormWrapper()}>
                     Start New Campaign
                   </Button>
                 </div>
          }
          { user && <CampaignTable stompClient={stompClient} editCampaign={editCampaign} user={user} refreshTrigger={refreshTrigger} /> }
          { showForm
              && <div className="campaign-modal-overlay">
                   <div className="campaign-modal-wrapper">
                     <CampaignForm campaign={editingCampaign} stompClient={stompClient} cancelForm={cancelForm} setBanner={setBanner} user={user} />
                   </div>
                 </div>
          }
        <Footer />
      </div>
    </HeroUIProvider>
  );
}

export default App;
